<div class="main">
    <div class="dx-field-title" translate>globalAdmins.pageTitle</div>
    <div class="dx-fieldset" style="height:calc(100vh - 160px)">
        <dx-data-grid #adminsGrid
                      [dataSource]="admins"
                      keyExpr="user.id"
                      [showRowLines]="true"
                      [columnAutoWidth]="true"
                      [focusedRowEnabled]="true"
                      height="100%"
                      hoverStateEnabled="true"
                      [wordWrapEnabled]="true"
                      (onEditorPreparing)="onEditorPreparing($event)"
                      (onContextMenuPreparing)="onContextMenuPreparing($event)"
                      (onRowDblClick)="onRowDblClick($event)">
            <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
            <dxo-header-filter></dxo-header-filter>
            <dxo-paging [enabled]="false"></dxo-paging>
            <dxo-summary>
                <dxi-total-item column="user.properties.displayName" [displayFormat]="'_commons.adminsCount' | translate" summaryType="count"></dxi-total-item>
            </dxo-summary>
            <dxo-toolbar>
                <dxi-item location="after">
                    <div *dxTemplate>
                        <dx-button icon="add" [text]="'_commons.add' | translate" (onClick)="showCreatePopup()"></dx-button>
                    </div>
                </dxi-item>
                <dxi-item location="after">
                    <div *dxTemplate>
                        <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="loadDataSource()"></dx-button>
                    </div>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>

            <!-- DataGrid columns -->
            <dxi-column [width]="100" dataField="user.photo" caption="" [allowSorting]="false" cellTemplate="pictureCellTemplate"></dxi-column>
            <dxi-column dataField="user.properties.displayName" [caption]="'_commons.name' | translate"></dxi-column>
            <dxi-column dataField="user.name" [caption]="'_commons.email' | translate" cellTemplate="mailCellTemplate"></dxi-column>
            <dxi-column dataField="canManageEnvironments" [caption]="'globalAdmins.lblManageEnvironments' | translate"
                        dataType="boolean"></dxi-column>
            <dxi-column dataField="canManageGlobalAdministrators" [caption]="'globalAdmins.lblManageGlobalAdmins' | translate"
                        dataType="boolean"></dxi-column>
            <!-- Custom cell templates -->
            <div *dxTemplate="let cell of 'mailCellTemplate'">
                <a href="mailto:{{cell.data.user.name}}">{{cell.data.user.name}}</a>
            </div>
            <div *dxTemplate="let cell of 'pictureCellTemplate'">
                <img class="img" [src]="cell.data.user.photo" alt="photo" width="48" height="48" />
            </div>
        </dx-data-grid>
    </div>
</div>

<!-- Create popup -->
<dx-popup [title]="'globalAdmins.popupCreateTitle' | translate" [height]="350" [(visible)]="createPopupVisible">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view direction="vertical">
            <dx-validation-group #adminValidationGroup>
                <div class="dx-field">
                    <div class="dx-field-label" translate>_commons.employee<span class="dx-field-item-required-mark">
                            *</span></div>
                    <div class="dx-field-value">
                        <app-employee-picker [(selectedItem)]="newAdmin.user" [isRequired]="true"></app-employee-picker>
                    </div>
                </div>
                <div class="dx-field">
                    <span class="dx-field-label" translate>globalAdmins.lblManageEnvironments</span>
                    <dx-switch [(value)]="newAdmin.canManageEnvironments"></dx-switch>
                </div>
                <div class="dx-field">
                    <span class="dx-field-label" translate>globalAdmins.lblManageGlobalAdmins</span>
                    <dx-switch [(value)]="newAdmin.canManageGlobalAdministrators"></dx-switch>
                </div>
                <div class="flex bottom-buttons">
                    <dx-button class="save" [text]="'_commons.add' | translate" (onClick)="createAdmin(newAdmin)"></dx-button>
                    <dx-button class="delete" [text]="'_commons.cancel' | translate" (onClick)="this.createPopupVisible = false"></dx-button>
                </div>
            </dx-validation-group>
        </dx-scroll-view>
    </div>
</dx-popup>

<!-- Edit popup -->
<dx-popup [title]="'globalAdmins.popupEditTitle' | translate" [height]="350" [(visible)]="editPopupVisible">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view direction="vertical">
            <div class="dx-field">
                <div class="dx-field-label" translate>_commons.employee</div>
                <div class="dx-field-value">{{editAdmin.user.properties.displayName}}</div>
            </div>
            <div class="dx-field">
                <span class="dx-field-label" translate>globalAdmins.lblManageEnvironments</span>
                <dx-switch [(value)]="editAdmin.canManageEnvironments"></dx-switch>
            </div>
            <div class="dx-field">
                <span class="dx-field-label" translate>globalAdmins.lblManageGlobalAdmins</span>
                <dx-switch [(value)]="editAdmin.canManageGlobalAdministrators"></dx-switch>
            </div>
            <div class="flex bottom-buttons">
                <dx-button class="save" [text]="'_commons.save' | translate" (onClick)="updateAdmin(editAdmin)"></dx-button>
                <dx-button class="delete" [text]="'_commons.cancel' | translate" (onClick)="this.editPopupVisible = false"></dx-button>
            </div>
        </dx-scroll-view>
    </div>
</dx-popup>
